// extracted by mini-css-extract-plugin
module.exports = {"announcements":"S_fR p-2","announcement":"S_fS card my-2","announcement--highlighted":"S_fT","announcement__list-item":"S_fV py-1","announcement__flag":"S_fW"};